import React from 'react';
import { withRouter } from 'react-router-dom';
import './PageNotFound.css';

class PageNotFound extends React.Component {
    handleHome = () => {
        this.props.history.push('/');
    };

    handleBack = () => {
        if (window.history.length > 1) {
            this.props.history.goBack();
        } else {
            this.props.history.push('/');
        }
    };

    render() {
        // `code` defaults to 404. Pass `code={403}` from a route guard
        // to render the restricted-access variant instead.
        const code = this.props.code === 403 ? 403 : 404;
        const isForbidden = code === 403;
        const heading = isForbidden ? 'Access Restricted' : 'Page Not Found';
        const message = isForbidden
            ? "You don't have permission to view this page. If you think this is a mistake, contact your administrator."
            : "We couldn't find the page you're looking for. It may have been moved, renamed, or never existed.";

        return (
            <div className="bnxa-error-page">
                <div className="bnxa-error-card">
                    <div className="bnxa-error-code" aria-hidden="true">{code}</div>

                    <h1 className="bnxa-error-heading">{heading}</h1>
                    <p className="bnxa-error-message">{message}</p>

                    <div className="bnxa-error-actions">
                        <button
                            type="button"
                            className="bnxa-error-btn bnxa-error-btn-primary"
                            onClick={this.handleHome}
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1V9.5z" />
                            </svg>
                            <span>Go Home</span>
                        </button>
                        <button
                            type="button"
                            className="bnxa-error-btn bnxa-error-btn-secondary"
                            onClick={this.handleBack}
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <line x1="19" y1="12" x2="5" y2="12" />
                                <polyline points="12 19 5 12 12 5" />
                            </svg>
                            <span>Go Back</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PageNotFound);
